import { DatePicker, Modal, Typography } from 'antd'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { calculateDefaultDueDate } from './batchInvoicingModel'
import { BatchScope, scopeDateLabel, scopeDivisionsLabel, scopeWorkAreaStatusesLabel } from './batchScopeModel'

const { Text } = Typography

type Props = {
  open: boolean
  onClose: () => void
  jobCount: number
  scope: BatchScope
  defaultDueInDays: number
  confirmLoading?: boolean
  onConfirm: (dueDate: string) => void
}

const CreateInvoicesModal = ({ open, onClose, jobCount, scope, defaultDueInDays, confirmLoading, onConfirm }: Props) => {
  const [dueDate, setDueDate] = useState(() => calculateDefaultDueDate(defaultDueInDays))

  useEffect(() => {
    if (open) {
      setDueDate(calculateDefaultDueDate(defaultDueInDays))
    }
  }, [open])

  const scopeRow = (label: string, value: string) => (
    <div style={{ display: 'flex', gap: 8 }}>
      <Text type="secondary" style={{ minWidth: 96 }}>{label}</Text>
      <Text strong>{value}</Text>
    </div>
  )

  return <Modal
    open={open}
    onCancel={onClose}
    onOk={() => onConfirm(dueDate)}
    okText="Create Invoices"
    confirmLoading={confirmLoading}
    title={`Create ${jobCount} ${jobCount === 1 ? 'invoice' : 'invoices'}`}
  >
    <div style={{
      backgroundColor: '#f5f5f5',
      borderRadius: 8,
      padding: 16,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      marginBottom: 16
    }}>
      <Text>Only work in this scope will be invoiced:</Text>
      {scopeRow('Date range', scopeDateLabel(scope))}
      {scopeRow('Divisions', scopeDivisionsLabel(scope))}
      {scopeRow('Work status', scopeWorkAreaStatusesLabel(scope))}
      <Text type="secondary" style={{ fontSize: 12 }}>
        To invoice a different scope, cancel and change the filters.
      </Text>
    </div>

    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span>Due date:</span>
      <DatePicker
        value={dayjs(dueDate)}
        onChange={(d) => setDueDate(d ? d.format('YYYY-MM-DD') : dueDate)}
        allowClear={false}
      />
    </div>
  </Modal>
}

export default CreateInvoicesModal
